import { render, staticRenderFns } from "./consumables-material.vue?vue&type=template&id=48351f58&scoped=true"
import script from "./consumables-material.vue?vue&type=script&lang=ts"
export * from "./consumables-material.vue?vue&type=script&lang=ts"
import style0 from "./consumables-material.vue?vue&type=style&index=0&id=48351f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48351f58",
  null
  
)

export default component.exports